import { createSelector } from 'reselect';
import getUnenhancedStagedPurchases from './getUnenhancedStagedPurchases';

export default createSelector(
  [getUnenhancedStagedPurchases],
  stagedPurchases => {
    return stagedPurchases.filter(purchase => purchase.unavailable);
  },
);
